module.exports = __webpack_public_path__ + "img/drag.23dd63ac.svg";